export default "__VITE_ASSET__Ca40oET9__"